module.exports = __webpack_public_path__ + "static/media/notepad.6b8703c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/notepad.png
// module id = 35
// module chunks = 0